import React, { useEffect, useState } from 'react';
import { Link as Anchor } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faHome, 
    faUsers, 
    faCogs, 
    faShieldAlt, 
    faChartLine,
    faCheckCircle,
    faClock,
    faUserTie,
    faPlayCircle,
    faSolarPanel,
    faBolt,
    faBatteryFull,
    faPlug,
    faTools,
    faMapMarkerAlt,
    faLeaf,
    faAward
} from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup';
import './PageNosotros.css';
import HeaderBack from '../../Components/HeaderBack/HeaderBack';

export default function PageNosotros() {
   const [imagesLoaded, setImagesLoaded] = useState(false);

   useEffect(() => {
        // Scroll suave al cargar en móvil
        if (window.innerWidth <= 768) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        
        // Marcar que las imágenes han comenzado a cargar
        setImagesLoaded(true);
    }, []);

    return (
        <div className="nosotros-page">
            {/* Encabezado con imagen de fondo - ESTRUCTURA BASE SIN MODIFICAR */}
            <div className='bgPage' style={{ 
                backgroundImage: imagesLoaded ? 
                    `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(/images/ban.jpg)` : 
                    'none',
                backgroundColor: imagesLoaded ? 'transparent' : 'var(--color1)'
            }}>
                <HeaderBack title='Nosotros' />
                <div className="breadcrumb">
                    <Anchor to="/">
                        <FontAwesomeIcon icon={faHome} /> Inicio
                    </Anchor>
                    <span>|</span>
                    <Anchor to=''>
                        Nosotros
                    </Anchor>
                </div>
            </div>

            {/* Contenido Principal */}
            <div className="ProductsContainPage">
                <div className="nosotros-container">
                    {/* Sección Hero - ACTUALIZADA */}
                    <section className="hero-section">
                        <h1>Energías Perú - Inversiones Anahí</h1>
                    </section>

                    {/* Sección Quiénes Somos - ACTUALIZADA */}
                    <section className="info-section">
                        <div className="section-header">
                            <FontAwesomeIcon icon={faUsers} className="section-icon" />
                            <h2>Quiénes Somos</h2>
                        </div>
                        <div className="section-content">
                            <p>Somos una empresa peruana con sede en Atalaya, especializada en la venta de kits solares, accesorios eléctricos y servicio técnico especializado. Nuestro compromiso es llevar energía limpia y accesible a hogares, negocios y comunidades de nuestra región.</p>
                            <p>En Inversiones Anahí creemos en un futuro sostenible. Por eso ofrecemos productos de alta calidad, desde paneles solares hasta controladores, inversores y todo tipo de accesorios eléctricos, respaldados por un servicio técnico confiable y atención personalizada.</p>
                            <div className="stats-grid">
                                <div className="stat-card">
                                    <FontAwesomeIcon icon={faSolarPanel} size="2x" style={{color: "white", marginBottom: "1rem"}} />
                                    <h3><CountUp end={5} duration={2} />+</h3>
                                    <p>Años en el mercado</p>
                                </div>
                                <div className="stat-card">
                                    <FontAwesomeIcon icon={faUserTie} size="2x" style={{color: "white", marginBottom: "1rem"}} />
                                    <h3><CountUp end={200} duration={2} />+</h3>
                                    <p>Clientes satisfechos</p>
                                </div>
                                <div className="stat-card">
                                    <FontAwesomeIcon icon={faBolt} size="2x" style={{color: "white", marginBottom: "1rem"}} />
                                    <h3><CountUp end={300} duration={2} />+</h3>
                                    <p>Sistemas instalados</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Sección Nuestros Servicios - ACTUALIZADA */}
                    <section className="info-section">
                        <div className="section-header">
                            <FontAwesomeIcon icon={faCogs} className="section-icon" />
                            <h2>Nuestros Servicios</h2>
                        </div>
                        <div className="services-grid">
                            <div className="service-card">
                                <FontAwesomeIcon icon={faSolarPanel} style={{color: "var(--color1)", fontSize: "1.8rem", marginBottom: "1rem"}} />
                                <h3>Venta de Kits Solares</h3>
                                <p>Sistemas completos para hogar, negocio y campo, con paneles de alta eficiencia, baterías y controladores de última generación.</p>
                            </div>
                            <div className="service-card">
                                <FontAwesomeIcon icon={faBatteryFull} style={{color: "var(--color1)", fontSize: "1.8rem", marginBottom: "1rem"}} />
                                <h3>Baterías y Almacenamiento</h3>
                                <p>Baterías de ciclo profundo y sistemas de almacenamiento para garantizar energía continua incluso en horas sin sol.</p>
                            </div>
                            <div className="service-card">
                                <FontAwesomeIcon icon={faTools} style={{color: "var(--color1)", fontSize: "1.8rem", marginBottom: "1rem"}} />
                                <h3>Servicio Técnico</h3>
                                <p>Instalación profesional, mantenimiento preventivo y correctivo de paneles, inversores, controladores y conversores.</p>
                            </div>
                            <div className="service-card">
                                <FontAwesomeIcon icon={faPlug} style={{color: "var(--color1)", fontSize: "1.8rem", marginBottom: "1rem"}} />
                                <h3>Accesorios Eléctricos</h3>
                                <p>Cables, termomagnéticas, cuchillas, luminarias, desarmadura, llaves y todo lo necesario para instalaciones eléctricas.</p>
                            </div>
                        </div>
                    </section>

                    {/* Sección Nuestra Ventaja Competitiva - ACTUALIZADA */}
                    <section className="info-section">
                        <div className="section-header">
                            <FontAwesomeIcon icon={faShieldAlt} className="section-icon" />
                            <h2>Nuestra Ventaja</h2>
                        </div>
                        <div className="advantages-grid">
                            <div className="advantage-item">
                                <FontAwesomeIcon icon={faAward} style={{color: "var(--color1)", marginBottom: "1rem", fontSize: "1.8rem"}} />
                                <h3>Productos Certificados</h3>
                                <p>Todos nuestros paneles, baterías y accesorios cuentan con certificaciones internacionales de calidad y eficiencia energética.</p>
                            </div>
                            <div className="advantage-item">
                                <FontAwesomeIcon icon={faMapMarkerAlt} style={{color: "var(--color1)", marginBottom: "1rem", fontSize: "1.8rem"}} />
                                <h3>Presencia Local</h3>
                                <p>Ubicados estratégicamente en Atalaya para atender de manera rápida y personalizada a clientes de toda la región Ucayali.</p>
                            </div>
                            <div className="advantage-item">
                                <FontAwesomeIcon icon={faLeaf} style={{color: "var(--color1)", marginBottom: "1rem", fontSize: "1.8rem"}} />
                                <h3>Compromiso Ambiental</h3>
                                <p>Promovemos el uso de energías renovables para reducir la huella de carbono y construir un futuro más sostenible.</p>
                            </div>
                        </div>
                    </section>

                    {/* Sección: Video Corporativo - ACTUALIZADO */}
                    <section className="info-section">
                        <div className="section-header">
                            <FontAwesomeIcon icon={faPlayCircle} className="section-icon" />
                            <h2>Energía solar en acción</h2>
                        </div>
                        <div className="video-container">
                            <iframe 
                                src="https://www.youtube.com/embed/3UZ4Gqhpu1U" 
                                title="Energía Solar - Energías Perú" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowFullScreen
                                className="responsive-iframe"
                            />
                        </div>
                        <p style={{textAlign: 'center', marginTop: '1rem', color: '#666'}}>
                            Conoce cómo nuestros sistemas solares están llevando energía limpia a hogares y negocios en Atalaya.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
}